import { NavLink } from 'react-router-dom'
//import menuItems from "@/data/menuItems";
//import { isParentActive } from "@/utils/isMenuActive";
//import Link from "next/link";
//import { usePathname } from "next/navigation";

const MainMenu = ({t}) => {
    //const path = usePathname();

    return (
        <>  
            <li key={1}>
                <NavLink exact to="/" activeClassName="selected" >
                    {t('header.home')}
                </NavLink>
            </li>
            <li key={2}>
                <NavLink exact to="/listing" activeClassName="selected" className="" >
                    {t('header.stock')}
                </NavLink>
            </li>
            <li key={3}>
                <NavLink exact to="/services" activeClassName="selected" className="" >
                    {t('header.services')}
                </NavLink>
            </li>
            <li key={3}>
                <a href='https://truckcabin.jp'activeClassName="selected" className="" target='_blank'>
                    {t('header.parts')}
                </a>
            </li>
            <li key={5}>
                <NavLink exact to="/about" activeClassName="selected" className="" >
                    {t('header.about-us')}
                </NavLink>
            </li>
            <li key={4}>
                <NavLink exact to="/contact" activeClassName="selected" className="" >
                    {t('header.contact-us')}
                </NavLink>
            </li>

            {/* --------- */}
            {/* {menuItems.map((menuItem, index) => (
                <>
                    {menuItem.subMenu ? (
                        <li className="dropitem" key={index}>
                            <a
                                className={
                                    isParentActive(menuItem.subMenu, path)
                                        ? "active"
                                        : ""
                                }
                                href="#"
                            >
                                <span className="title">{menuItem.label}</span>
                                <span className="arrow"></span>
                            </a>
                            <ul className="sub-menu">
                                {menuItem.subMenu?.map((subItem, subIndex) => (
                                    <li key={subIndex} className="dropitem">
                                        {subItem.subMenu ? (
                                            <>
                                                <a
                                                    className={
                                                        isParentActive(
                                                            subItem.subMenu,
                                                            path
                                                        )
                                                            ? "active"
                                                            : ""
                                                    }
                                                    href="#"
                                                >
                                                    {subItem.label}
                                                </a>
                                                <span className="arrow"></span>
                                                <ul className="sub-menu">
                                                    {subItem.subMenu.map(
                                                        (
                                                            nestedSubItem,
                                                            nestedSubIndex
                                                        ) => (
                                                            <li key={nestedSubIndex}>
                                                                <Link
                                                                    className={
                                                                        path ===
                                                                            nestedSubItem.path
                                                                            ? "active"
                                                                            : ""
                                                                    }
                                                                    href={
                                                                        nestedSubItem.path
                                                                    }
                                                                >
                                                                    {
                                                                        nestedSubItem.label
                                                                    }
                                                                </Link>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </>
                                        ) : (
                                            <Link
                                                href={subItem.path}
                                                className={
                                                    path === subItem.path
                                                        ? "active"
                                                        : ""
                                                }
                                            >
                                                {subItem.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ) : (
                        <li key={index}>
                            <Link
                                href={menuItem.path}
                                className={
                                    path === menuItem.path
                                        ? "active"
                                        : ""
                                }
                            >
                                {menuItem.label}
                            </Link>
                        </li>
                    )}

                </>

            ))} */}
        </>
    );
};

export default MainMenu;
